import React, {
  useCallback,
} from 'react';
import {
  shallowEqual,
  useSelector,
} from 'react-redux';
import i18n from 'i18next';

import {
  coreSelectors,
} from '@gymcloud/core';
import {
  useProgram,
} from 'web-hooks';

import {
  Button,
  CreatableEntityButton,
} from 'web-components';

import {
  Flex,
  Text,
  SVG,
} from 'web-styled';

import * as S from './styled';

type Props = {
  readOnly: boolean,
  programId: number,
  resourceType: string,
};

const EmptyState = ({
  readOnly,
  resourceType,
  programId,
}: Props) => {
  const isPersonal = resourceType === 'personalPrograms';

  const mapState = useCallback((state) => {
    const program = coreSelectors.getResourceById(
      resourceType,
      programId,
    )(state);
    return {
      workoutOptions: coreSelectors.getProgamWorkoutOptions(
        isPersonal ? program.person_id : 'me',
      )(state),
    };
  }, [programId, resourceType]);

  const {
    workoutOptions,
  } = useSelector(mapState, shallowEqual);
  const {
    requestAddWeek,
    requestAddWorkout,
  } = useProgram({ programId, resourceType });

  return (
    <Flex
      align="center"
      justify="center"
      width="100%"
      height="650px"
      margin="0 0 0 -20%"
    >
      <S.Empty>
        <SVG.Program stroke="#cccccc" />
        <Text color="#cccccc">
          {i18n.t('program.empty')}
        </Text>
        {!readOnly && (
          <Flex align="center" spacing={0} column width="300px">
            <Button
              ghost
              appearance="primary"
              icon={<SVG.Plus size={14} strokeWidth={4} />}
              onClick={requestAddWeek}
              style={{ width: '120px' }}
            >
              Add Week
            </Button>
            <Text color="#cccccc">
              or
            </Text>
            <CreatableEntityButton
              buttonProps={{
                ghost: true,
                appearance: 'primary',
                style: { width: '120px' },
              }}
              options={workoutOptions}
              placeholder={i18n.t('search.placeholder.workoutTemplates')}
              tooltip={i18n.t('tooltip.program.add.workouts')}
              buttonLabel={i18n.t('add.workout')}
              menuPlacement="bottom"
              onRequestAdd={requestAddWorkout}
              onRequestAddNew={requestAddWorkout}
            />
          </Flex>
        )}
      </S.Empty>
    </Flex>
  );
};

export default EmptyState;
